import { FormHelperText, Slider } from "@mui/material";
import PropTypes from "prop-types";

import { FormRow, FormSection, FormSectionHeader, InputContainer } from ".";

/**
 * Min/max light level (low/high end trim) slider configuration section.
 *
 * @param root0 - The component props.
 * @param root0.localSettings - The local settings state.
 * @param root0.updateLocalSettings - Callback to update local settings.
 * @param root0.commitSettings - Callback to commit settings changes.
 * @returns The rendered light levels section.
 */
const SectionLightLevels = ({
    localSettings,
    updateLocalSettings,
    commitSettings,
}) => (
    <FormSection>
        <FormSectionHeader>
            <h2>Min and Max Light Levels</h2>
            <p>
                Min (low end trim) and max (high end trim) levels are inherited
                from the default controller min and max levels set for all
                groups. These can be further customized within those ranges for
                each group. They can also be overridden at the store level as
                well.
            </p>
        </FormSectionHeader>
        <FormRow>
            <InputContainer>
                <FormHelperText>Group Low End Trim (%)</FormHelperText>
                <Slider
                    value={localSettings.minLightLevel ?? 0}
                    valueLabelDisplay="auto"
                    onChange={(_, value) =>
                        updateLocalSettings({ minLightLevel: value })
                    }
                    onChangeCommitted={commitSettings}
                />
            </InputContainer>
            <InputContainer>
                <FormHelperText>Group High End Trim (%)</FormHelperText>
                <Slider
                    value={localSettings.maxLightLevel ?? 0}
                    valueLabelDisplay="auto"
                    onChange={(_, value) =>
                        updateLocalSettings({ maxLightLevel: value })
                    }
                    onChangeCommitted={commitSettings}
                />
            </InputContainer>
        </FormRow>
    </FormSection>
);

SectionLightLevels.propTypes = {
    localSettings: PropTypes.object,
    updateLocalSettings: PropTypes.func,
    commitSettings: PropTypes.func,
};

export default SectionLightLevels;
